import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4800Model } from '../kymw4800.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * クロス商品設定一覧更新サービス
 * @export UpdateBuyerCrossGoodsSetMasterListService
 * @class UpdateBuyerCrossGoodsSetMasterListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateBuyerCrossGoodsSetMasterListService extends PlessJsonResponderSub<any> {
  private model: KYMW4800Model;
  private successFunc: Function;
  private exceptionErrorFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateBuyerCrossGoodsSetMasterListService
   */
  private getBody(): PlessRequest {
    const req = [];
    for (const e of this.model.originalCrossGoodsList) {
      for (const ee of this.model.crossGoodsMap[e.CrossCode]) {
        // Pコードが-の場合は表示用に追加したものなのでリクエストに含めない
        if (ee.PCode !== '-') {
          if (this.model.deleteCrossCodeList.includes(e.CrossCode)) {
            // 削除時はAPI取得時のデータを使用
            req.push({
              condition: {
                CrossCode: e.CrossCode,
                MediumType: this.model.mediumType,
                AutoDefaultSettings: e.AutoDefaultSettings ? 1 : 0,
                FormDispFlag: 1,
                PCode: ee.PCode,
                ChildKomaSettings: ee.ChildKomaSettings ? 1 : 0
              },
            })
          } else {
            // 削除されていない場合は表示されている最新データを使用
            let target;
            for (const ee of this.model.crossGoodsList) {
              if (e.CrossCode === ee.CrossCode) {
                target = ee;
                break;
              }
            }
            req.push({
              condition: {
                CrossCode: target.CrossCode,
                MediumType: target.MediumType,
                AutoDefaultSettings: target.AutoDefaultSettings ? 1 : 0,
                FormDispFlag: 0,
                PCode: ee.PCode,
                ChildKomaSettings: ee.ChildKomaSettings ? 1 : 0
              },
            })
          }
        }
      }
    }

    return new PlessRequest({
      update: {
        UpdateBuyerCrossGoodsSetMasterList: {
          combination: req
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4800Model} model モデルクラス
   * @param {Function} successFunc 成功時後続処理
   * @memberof UpdateBuyerCrossGoodsSetMasterListService
   */
  execute(model: KYMW4800Model, successFunc: Function, exceptionErrorFunc: Function): void {
    this.model = model;
    this.successFunc = successFunc;
    this.exceptionErrorFunc = exceptionErrorFunc;
    this.send('updateBuyerCrossGoodsSetMasterList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateBuyerCrossGoodsSetMasterListService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof UpdateBuyerCrossGoodsSetMasterListService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
